import FormsAPI from '@/modules/forms/api/forms'

export default {
  getFormAnswerByRelatable({ commit }, { foreignType, foreignId }) {
    return FormsAPI.getFormAnswerByRelatable(foreignType, foreignId).then((data) => {
      commit('setAnswer', data)
    })
  },
}
